import React, { Component } from "react";

class Documents extends Component {
  render() {
    return <div>A user can see relevant documents here</div>;
  }
}

export default Documents;
